import { DEFAULTS } from "./defaults";
import { tiptapExtensions } from "./tiptap/tiptap";
import { HASHTAG_TYPE } from "./types";
const pluginHashtag = (config) => {
  const pluginConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: HASHTAG_TYPE,
    tiptapExtensions
  };
};
export {
  pluginHashtag
};
//# sourceMappingURL=editor.js.map

import { injectCss } from "./viewer-styles-inject";
injectCss();
